import { render } from "./MaterialCardView.vue?vue&type=template&id=bdea90ec&scoped=true"
import script from "./MaterialCardView.vue?vue&type=script&lang=js"
export * from "./MaterialCardView.vue?vue&type=script&lang=js"

import "./MaterialCardView.vue?vue&type=style&index=0&id=bdea90ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdea90ec"]])

export default __exports__